/**
 * @generated SignedSource<<8fad68a3297167784b107b3d199326b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type TodoToolbarEdit_todo$data = {
  readonly assigned: ReadonlyArray<{
    readonly __typename: "AssignedEmployee";
    readonly employee: {
      readonly " $fragmentSpreads": FragmentRefs<"ToolbarButtonAssignees_employees">;
    } | null;
  }>;
  readonly assignedRoles: ReadonlyArray<{
    readonly __typename: "AssignedRole";
    readonly role: {
      readonly " $fragmentSpreads": FragmentRefs<"ToolbarButtonAssignees_roles">;
    };
  }>;
  readonly canWrite: boolean;
  readonly category: {
    readonly tags: ReadonlyArray<{
      readonly __typename: "TodoCategoryTag";
    }>;
  } | null;
  readonly expireAtDate: {
    readonly __typename: "StoreZonedDate";
    readonly isoString: string;
    readonly storeFormattedDate: string;
  } | null;
  readonly isOrg: boolean;
  readonly priority: TodoPriority;
  readonly tags: ReadonlyArray<{
    readonly __typename: "TodoCategoryTag";
    readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTags_tags">;
  }>;
  readonly teams: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTeams_teams">;
  }>;
  readonly " $fragmentType": "TodoToolbarEdit_todo";
};
export type TodoToolbarEdit_todo$key = {
  readonly " $data"?: TodoToolbarEdit_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarEdit_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoToolbarEdit_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "expireAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "style",
              "value": "DEFAULT"
            }
          ],
          "kind": "ScalarField",
          "name": "storeFormattedDate",
          "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedEmployee",
      "kind": "LinkedField",
      "name": "assigned",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ToolbarButtonAssignees_employees"
            }
          ],
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ToolbarButtonAssignees_roles"
            }
          ],
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoToolbarButtonTags_tags"
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoToolbarButtonTeams_teams"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoCategoryTag",
          "kind": "LinkedField",
          "name": "tags",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "1e0c3f024a4efa9cfeb5718b862e0f78";

export default node;
